import React from "react";
import Navbar from "../Navbar/Navbar";
import TopBar from "../TopBar/TopBar";

import Footer from "../Footer/Footer";
import "./NewsItem.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

import { BsWhatsapp } from "react-icons/bs";
import { news } from "../../utils/data";
import SummerCamp from "./SummerCamp";

const NewsItem = () => {
  const location = useLocation();
  const { slug } = useParams();

  const [mainNews, setMainNews] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    setMainNews(news.find((newsItem) => newsItem.slug === slug));
  }, [location]);

  const selectMainNews = (news_slug) => {
    setMainNews(news.find((newsItem) => newsItem.slug === news_slug));
  };

  return (
    <div>
      <TopBar />
      <Navbar />
      <div id="news-item-section">
        <div className="main-news">
          <h1 className="news-item-title">{mainNews?.title}</h1>
          <p className="news-item-description">{mainNews?.date}</p>
          <div
            className="news-item-main-image"
            style={{
              backgroundImage: `url(${mainNews?.image})`,
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              height: "500px",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* <img src={mainNews?.image} alt="graduation" /> */}
          </div>
          <p className="news-item-body">
            {mainNews?.slug === "cultural-diversity-day" && (
              <>
                <p>
                  This year's Cultural Diversity Day at our school, held on
                  March 5th, 2024, was a vibrant celebration of unity and
                  cultural heritage. Throughout the day, students and staff came
                  together to honor the rich tapestry of ethnic groups
                  represented within our school community.
                </p>{" "}
                <br />
                <p>
                  One of the highlights of the event was a lively cooking
                  competition held in the school playground. Staff members
                  showcased their culinary skills by preparing a diverse array
                  of dishes, each representing a different ethnic group.
                  Meanwhile, students dazzled in traditional attire as they
                  participated in a fashion show, proudly displaying the vibrant
                  colors and designs of their cultural dress.
                </p>{" "}
                <br />
                <p>
                  Mr. Twumasi, the Head of Department for the Grade School,
                  served as the Master of Ceremony, emphasizing the significance
                  of unity and solidarity among all members of our community.
                  Eliora Kumi Boateng, a Year 6 student, captivated the audience
                  with her eloquent speech, providing insightful introductions
                  to each dish prepared by the staff and sharing the historical
                  significance behind them.
                </p>
                <br />
                <p>
                  The event was not only entertaining but also educational,
                  leaving a lasting impression on both students and staff alike.
                  Photographs captured the memorable moments shared throughout
                  the day, serving as a testament to the joyous occasion. As the
                  program drew to a close, students and staff came together to
                  taste the diverse array of foods, symbolizing the spirit of
                  cultural exchange and appreciation. The competition concluded
                  with the presentation of awards to the deserving winners,
                  culminating in a sense of pride and unity among all
                  participants.
                </p>
              </>
            )}
            {mainNews?.slug === "book-character-day" && (
              <>
                <p>
                  To celebrate our students' love for storytelling and comic
                  books, we organized a lively event known as Book Character
                  Day. This special day, held on March 12th, 2024, saw our
                  school transformed into a vibrant showcase of beloved literary
                  and comic book heroes.
                </p>{" "}
                <br />
                <p>
                From Cinderella to Batman, Dora the Explorer to Spider-Man (a clear favorite among the students), our students donned an array of costumes representing their favorite characters. The festivities kicked off at 8am in the school playground, where students gathered for a pre-photo session, capturing the excitement and creativity of their character portrayals.
                </p>
                <br />
                <p>
                  Mr. Joseph Boateng, a dedicated facilitator and the Master of
                  Ceremony for the event, engaged students in discussions about
                  the characters they embodied, highlighting their knowledge and
                  passion for reading. Encouraging them to delve even deeper
                  into the world of literature, Mr. Boateng emphasized the
                  importance of continued reading.
                </p>
                <br />
                <p>
                  Throughout the day, students enthusiastically demonstrated how
                  their chosen characters behaved, sparking friendly
                  competitions and lively interactions. Video recordings and
                  photographs captured these memorable moments, adding to the
                  excitement and ensuring the event would be cherished for years
                  to come.
                </p>
                <br />
                <p>
                  Such was the enthusiasm among students that many were
                  reluctant to leave when the school day drew to a close. Book
                  Character Day proved to be not only an entertaining event but
                  also an educational one, as both students and staff discovered
                  new insights and perspectives through their shared love of
                  literature.
                </p>
              </>
            )}
            {mainNews?.slug === "parent-facilitator-conference" && (
              <>
                <p>
                  To demonstrate our commitment to parental involvement in their
                  children's education, we host an annual event known as the
                  Parent-Facilitator Conference. This year’s event took place on
                  Monday, March 11th, 2024, to serve as an opportunity for
                  parents to actively engage with facilitators to gain insights
                  into their children's academic progress and well-being.
                </p>
                <br />
                <p>
                  Beginning at 7 am, parents arrived at the school with their
                  children, initiating one-on-one interactions with
                  facilitators. These discussions covered various aspects of
                  their child's development, including academic performance,
                  behavior, challenges, and other pertinent topics. Together,
                  parents and facilitators explored solutions and strategies to
                  support the child's growth and success. Throughout these
                  sessions, still photos were captured, preserving the moments
                  of collaboration and engagement.
                </p>
                <br />
                <p>
                  In addition to these discussions, facilitators recommended
                  specific books for parents to purchase for their children. To
                  facilitate this process and ensure accessibility, the school
                  organized a Book Fair on the same day. A diverse selection of
                  books was showcased, including storybooks, subject-based
                  resources, and titles on technology, among others. Parents had
                  the opportunity to browse the selection alongside their
                  children, making informed choices based on the recommendations
                  provided by facilitators.
                </p>{" "}
                <br />
                <p>
                  The Book Fair served as a platform for fostering unity and
                  understanding between parents and facilitators. Facilitators
                  patiently addressed any questions or inquiries raised by
                  parents, further strengthening the collaborative relationship
                  between home and school.
                </p>
                <br />
                <p>
                  As the day drew to a close, students departed with a sense of
                  happiness and security, knowing that their parents and the
                  school are working together in their best interest. The
                  Parent-Facilitator Conference not only reinforced the
                  importance of parental involvement but also highlighted the
                  shared commitment to the educational journey of each child
                  within the school community.
                </p>
              </>
            )}
            {mainNews?.slug === "ghana-chocolate-day" && (
              <>
                <p>
                  The school celebrated Ghana Chocolate Day with a unique and
                  engaging approach, focusing on the theme "The Relevance of
                  Ghanaian Cocoa and the Impact of Galamsey." On Wednesday,
                  February 14th, 2024, staff and students alike arrived at
                  school dressed in vibrant red attire to signify the importance
                  of the occasion. A photographer welcomed them with open arms,
                  capturing the spirit of the day through photographs.
                </p>
                <br />
                <p>
                  Throughout the day, facilitators and students delved into the
                  significance of Ghanaian cocoa, highlighting its crucial role
                  as a major source of income for the country. They also
                  explored the detrimental effects of galamsey, or illegal
                  mining, on our natural resources, particularly cocoa
                  production.
                </p>
                <br />
                <p>
                  In the Grade School, facilitators gathered their students for
                  a practical demonstration on how chocolate is made. Led by
                  Miss Abigail Frimpong, facilitators engaged students in
                  discussions about the various end-products of cocoa, with
                  students displaying impressive knowledge. Through hands-on
                  activities, students gained insight into the chocolate-making
                  process, deepening their appreciation for Ghana's cocoa
                  industry.
                </p>
                <br />
                <p>
                  Meanwhile, in the Pre-school classes, Miss Agnes Osei Bonsu
                  led fun and educational activities related to cocoa. Students
                  and facilitators alike had the opportunity to learn new and
                  insightful facts about Ghana's cocoa production, with some
                  students experiencing cocoa firsthand for the first time.
                  Still photographs were taken in each class, capturing the
                  excitement and learning that characterized the day.
                </p>{" "}
                <br />
                <p>
                  The Ghana Chocolate Day celebration was not only a festive
                  occasion but also a valuable educational experience, allowing
                  students to connect with Ghana's rich cultural heritage and
                  understand the importance of preserving our natural resources
                  for future generations.
                </p>
                <br />
              </>
            )}
            {mainNews?.slug === "community-helpers-day" && (
              <>
                <p>
                  On February 23rd, 2024, the Foundation class held its
                  inaugural event, aptly titled Community Helpers Day. This
                  special occasion aimed to express gratitude to the various
                  community helpers in our country and underscore the importance
                  of their invaluable contributions.
                </p>{" "}
                <br />
                <p>
                  As the event unfolded, students from the class adorned
                  themselves in a colorful array of costumes representing
                  different community helpers, such as lawyers, doctors,
                  teachers, military and police officers, firefighters, nurses,
                  and many others. The event took place within the welcoming
                  confines of the Foundation Class, where Miss Cynthia Marfo and
                  Ruth Quaicoe warmly greeted the children alongside a
                  photographer.
                </p>
                <br />
                <p>
                  Miss Cynthia Marfo eloquently articulated the indispensable
                  role of these community helpers in our society, emphasizing
                  that life would be considerably more challenging without their
                  dedicated service. Subsequently, Miss Ruth Quaicoe guided the
                  children dressed in similar profession costumes to pose for
                  photographs, capturing the spirit of appreciation and
                  admiration.
                </p>
                <br />
                <p>
                  Parents were visibly delighted and proud to witness their
                  children enthusiastically embracing the roles of community
                  helpers, as evidenced by their joyous reactions to the
                  photographs.
                </p>
                <br />
                <p>
                  Mrs. Ellen Antwiwaa Sarkodie (Director), Mr. Asare Opoku Eric
                  (Administrator), and Mr. Philips Pimpong (Head of Academics)
                  commended the facilitators of the Foundation class for
                  organizing such a meaningful and impactful event, urging them
                  to continue their efforts in nurturing young minds.
                </p>
                <p>
                  By the day's end, the children were abuzz with excitement,
                  their imaginations ignited by the experience. Many had already
                  begun contemplating the professions they aspired to pursue in
                  the future, inspired by the admirable examples set by the
                  community helpers they had emulated. Community Helpers Day not
                  only celebrated the invaluable work of these individuals but
                  also planted seeds of ambition and gratitude within the hearts
                  of the next generation.
                </p>
              </>
            )}
            {mainNews?.slug === "summer-camp" && (
              <SummerCamp />
            )}
            {mainNews?.slug === "education-summit" && (
              <>
                <p>
                From time immemorial, education has played a significant role in shaping nations. In the 21st century, education has seen numerous positive changes that have brought about great transformation worldwide, especially in Ghana. For this reason, Anell School of Excellence was duly represented at this year's Ghana ASCD International Summit, which took place from Friday, July 5th to Sunday, July 7th, 2024, with the theme "Re-Imagining Education for the Future We Seek."
                </p>{" "}
                <br />
                <p>
                Our team, led by Mrs. Ellen Antwiwaa Sarkodie (Co-Founder and Managing Director), Mr. Eric Opoku Asare (Administrative Manager), and Mr. Philips Pimpong (Head of Academics), elevated networking to new heights by establishing contacts with educators from the UK, US, Canada, and other African countries, which will undoubtedly benefit our school in the near future.
                </p>
                <br />
                <p>
                Dr. Charles Yeboah (Director General of Ghana ASCD and Co-Founder and Managing Director of ICS Ghana), who also serves as the guest and keynote speaker for our 2024 graduation ceremony, delivered a powerful closing speech at the summit. He called for unity among educators in Ghana to work together for the reformation of the country's education system and emphasized that educators should not rely on politicians to bring about the desired reforms.
                </p>
                <br />
                <p>
                The educational experiences we gained and the memories we made during this summit will forever be a part of us. Other notable educators present included Dr. Patrick Awuah (Founder and President of Ashesi University), Mr. Enock Oye (Vice Principal and Head of Curriculum Planning and Professional Development at International Community School), and many others.
                </p>
                <br />
                
              </>
            )}
            {mainNews?.slug === "ghana-my-homeland" && (
              <>
                <p>
                As part of their Oral & Auditory lessons on Ghana and its history, the Reception and Year 1 classes held an event dubbed "Ghana My Homeland" on Friday, June 14th, 2024, to showcase their knowledge about Ghana and celebrate its forefathers and their immense contributions in the fight for independence.
                </p>{" "}
                <br />
                <p>
                On the day of the activity, children and facilitators from the mentioned classes dressed in 1980s attire to mark the occasion. A photographer welcomed the children and facilitators at the school's entrance, capturing photos as they arrived. At 8 AM, the children, accompanied by their facilitators, proceeded to the playground where Mr. Eric Asare Opoku, the Administrator, took video shots of the kids and their facilitators.
                </p>
                <br />
                <p>
                Mr. Philip Elikem, a facilitator and the Master of Ceremony, welcomed the children and invited Miss Janet Gyamfi and Miss Agnes Osei Bonsu, also facilitators, to explain the reason for the gathering. The day was filled with a variety of fun and educational activities such as modeling and photoshoots, dancing chair competition, a dancing competition to tunes from the 80s, recitation of the sixteen regions of Ghana and their capitals, as well as the names of the Big Six.
                </p>
                <br />
                <p>
                As the activity came to an end, the children were reluctant to return to their classes, having had a lot of fun. They left for their various homes with newfound knowledge and eagerly anticipated similar activities in the future.
                </p>
                <br />
                
              </>
            )}
          </p>
          <div className="event-images">
            {mainNews?.images?.map((image, index) => (
              <div key={index} className="event-image">
                <img src={image} alt="" loading="lazy" />
              </div>
            ))}
          </div>
          <br />
          <div>
            {mainNews?.links && (
              <div>
                View More Here:
                <ul style={{ listStyle: "none" }}>
                  {mainNews?.links?.map((link, index) => (
                    <li key={index}>
                      <Link to={link}>Link {index + 1}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="recent-posts">
          <h2 className="recent-posts-title">Recent Posts</h2>
          <ul className="recent-posts-list">
            {news.map((newsItem, index) => (
              <li
                onClick={() => selectMainNews(newsItem.slug)}
                key={index}
                className="recent-post"
              >
                <Link to={`/news-events/news/${newsItem.slug}`}>
                  {newsItem.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Link
        to="https://wa.me/2330504828824?text="
        target="_blank"
        id="whatsapp-icon"
      >
        <BsWhatsapp />
      </Link>
      <Footer />
    </div>
  );
};

export default NewsItem;
